import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import ModelsPage from "@/pages/ModelsPage";
import CarsPage from "@/pages/CarsPage";
import HousesPage from "@/pages/HousesPage";
import MarketingPage from "@/pages/MarketingPage";
import DealsPage from "@/pages/DealsPage";
import ConsultationPage from "@/pages/ConsultationPage";
import LoginPage from "@/pages/LoginPage";
import AccountPage from "@/pages/AccountPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentPages";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import OrdersAdmin from "@/pages/admin/OrdersAdmin";
import ListingsAdmin from "@/pages/admin/ListingsAdmin";
import MarketingAdmin from "@/pages/admin/MarketingAdmin";
import ClientsAdmin from "@/pages/admin/ClientsAdmin";
import SiteAdmin from "@/pages/admin/SiteAdmin";
import DiscountsAdmin from "@/pages/admin/DiscountsAdmin";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/models" element={<ModelsPage />} />
              <Route path="/cars" element={<CarsPage />} />
              <Route path="/houses" element={<HousesPage />} />
              <Route path="/marketing" element={<MarketingPage />} />
              <Route path="/deals" element={<DealsPage />} />
              <Route path="/consultation" element={<ConsultationPage />} />
              <Route path="/account" element={<AccountPage />} />
            </Route>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Overview />} />
              <Route path="orders" element={<OrdersAdmin />} />
              <Route path="listings" element={<ListingsAdmin />} />
              <Route path="marketing" element={<MarketingAdmin />} />
              <Route path="clients" element={<ClientsAdmin />} />
              <Route path="site" element={<SiteAdmin />} />
              <Route path="discounts" element={<DiscountsAdmin />} />
            </Route>
          </Routes>
          <Toaster position="top-right" theme="dark" />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
